import React from "react";
import "./HairStyling.css";

function HairStyling(props) {
  const { className } = props;

  return (
    <div className={`hair-styling-3 border-1px-sonic-silver ${className || ""}`}>
      <div className="hair-styling-2 poppins-medium-tundora-10px">HAIR STYLING</div>
    </div>
  );
}

export default HairStyling;
